import { ReactNode } from 'react';

import { useSlideResize } from '../activity-builder-slide.hooks';
import {
  ActivityBuilderSlideRow,
  ActivityBuilderSlide,
  ActivityBuilderSlideContent,
} from '../activity-builder-slide.style';

const ActivityBuilderDraftSlide = ({
  children,
  noContentPadding,
}: {
  children: ReactNode;
  noContentPadding?: boolean;
}) => {
  const { ref } = useSlideResize();

  return (
    <ActivityBuilderSlideRow ref={ref}>
      <ActivityBuilderSlide>
        {noContentPadding ? (
          children
        ) : (
          <ActivityBuilderSlideContent>{children}</ActivityBuilderSlideContent>
        )}
      </ActivityBuilderSlide>
    </ActivityBuilderSlideRow>
  );
};

export default ActivityBuilderDraftSlide;
